import { X } from 'lucide-react'
import { ExperienceSourceCard } from './ExperienceSourceCard'
import type { DisplaySource } from '@/types/source'

interface ExperienceSourcePanelProps {
  sources: DisplaySource[]
  onOpenSource: (source: DisplaySource) => void
  onClose?: () => void
}

export function ExperienceSourcePanel({ sources, onOpenSource, onClose }: ExperienceSourcePanelProps) {
  return (
    <div className="h-full flex flex-col">
      {/* Panel header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-border">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-foreground">Sources</span>
          {sources.length > 0 && (
            <span className="text-[11px] font-medium px-2 py-0.5 rounded-full bg-primary/10 text-primary">
              {sources.length} found
            </span>
          )}
        </div>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="p-1 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
            title="Hide sources"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>

      {/* Card list */}
      <div className="flex-1 overflow-y-auto p-3">
        {sources.length === 0 ? (
          <div className="flex items-center justify-center h-32 text-sm text-muted-foreground">
            Ask a question to see relevant sources
          </div>
        ) : (
          <div>
            {sources.map((source, index) => (
              <ExperienceSourceCard
                key={source.id}
                source={source}
                onOpenSource={onOpenSource}
                isFirst={index === 0}
                isLast={index === sources.length - 1}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
